export function moneyNumber(from: number | string, places = 2): number {
    const rounder = Math.pow(10, places)
    const rounderI = 1 / rounder
    const result = Number((Math.round((Number(from) * rounder)) * rounderI).toFixed(places))
    return result
}

export function moneyAdd(...nums: (string | number)[]): number {
    return moneyNumber(nums.map(n => moneyNumber(n, 6)).reduce((a, b) => a + b, 0))
}
